var exports = {
  "kL": "ChannelPermissionsTab.module__container___dmtKUG",
  "Ut": "ChannelPermissionsTab.module__syncBanner___dmtKUG",
  "iH": "ChannelPermissionsTab.module__syncBannerSynced___dmtKUG",
  "bT": "ChannelPermissionsTab.module__syncBannerUnsynced___dmtKUG",
  "Vg": "ChannelPermissionsTab.module__grid___dmtKUG",
  "s4": "ChannelPermissionsTab.module__leftTitle___dmtKUG",
  "pG": "ChannelPermissionsTab.module__right___dmtKUG",
  "ze": "ChannelPermissionsTab.module__rightScroller___dmtKUG",
  "CI": "ChannelPermissionsTab.module__sectionRow___dmtKUG",
  "bV": "ChannelPermissionsTab.module__sectionHeader___dmtKUG",
  "Gf": "ChannelPermissionsTab.module__sectionTitle___dmtKUG",
  "bQ": "ChannelPermissionsTab.module__subtleText___dmtKUG",
  "cy": "ChannelPermissionsTab.module__permHeaderRow___dmtKUG",
  "mA": "ChannelPermissionsTab.module__permHelp___dmtKUG",
  "p$": "ChannelPermissionsTab.module__emptyState___dmtKUG",
  "rV": "ChannelPermissionsTab.module__overwriteItem___dmtKUG",
  "w7": "ChannelPermissionsTab.module__overwriteItemSelected___dmtKUG",
  "Vd": "ChannelPermissionsTab.module__overwriteItemContextMenuOpen___dmtKUG",
  "FD": "ChannelPermissionsTab.module__overwriteIcon___dmtKUG",
  "m4": "ChannelPermissionsTab.module__roleDot___dmtKUG",
  "l": "ChannelPermissionsTab.module__overwriteName___dmtKUG",
  "Fs": "ChannelPermissionsTab.module__permSearchRow___dmtKUG",
  "XZ": "ChannelPermissionsTab.module__permSearchInput___dmtKUG",
  "sN": "ChannelPermissionsTab.module__layoutButtons___dmtKUG",
  "Zh": "ChannelPermissionsTab.module__layoutButton___dmtKUG",
  "HU": "ChannelPermissionsTab.module__permCategories___dmtKUG",
  "Fv": "ChannelPermissionsTab.module__mobileOverrideList___dmtKUG",
  "E_": "ChannelPermissionsTab.module__mobileListHeader___dmtKUG",
  "JJ": "ChannelPermissionsTab.module__mobileListTitle___dmtKUG",
  "_4": "ChannelPermissionsTab.module__mobileOverrides___dmtKUG",
  "Ud": "ChannelPermissionsTab.module__mobileOverrideItem___dmtKUG",
  "wP": "ChannelPermissionsTab.module__mobileOverrideName___dmtKUG",
  "wu": "ChannelPermissionsTab.module__mobileOverrideChevron___dmtKUG",
  "yg": "ChannelPermissionsTab.module__mobileBackRow___dmtKUG",
};

module.exports = exports;
